import { BnAction } from '../../common/bn-action';
import { sharedStyles } from '../../styles/shared-styles';
import { css } from '../../utility/lit-entity';

class UnassignButton extends BnAction {
  constructor() {
    super();
    this.actionname = 'unassign-work-order';
    this.errortext = 'Failed to un-assign work order.';
    this.successtext = 'Work Order has been un-assigned.';
    this.submittext = 'Un-Assign';
    this.suppressheader = true;
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: inline-block;
      }
    `];
  }

  preSubmit() {
    const referenceId = this.getProperty('referenceId');
    const confirmMessage = `Are you sure you want to un-assign work order #${referenceId}?`;
    return window.confirm(confirmMessage);
  }
}

window.customElements.define('unassign-button', UnassignButton);
